/**
 * Gateway product family + model labels from Supabase `gateways` row.
 *
 * Primary key: `hardware_type` (kgateway | lilygo_tsim7670g | wemos_lolin32).
 * Fallback: `hardware_model` (T-SIM7670G vs LOLIN32) when type was stored as lilygo_tsim7670g for both.
 */

const normalize = (value) => String(value || '').trim().toLowerCase();

export function getGatewayProductFamily(gateway) {
  const hwType = normalize(gateway?.hardware_type);
  const hwModel = normalize(gateway?.hardware_model);
  const mqttTopic = normalize(gateway?.mqtt_topic || gateway?.mqtt_pub_topic);

  if (hwType === 'wemos_lolin32' || hwModel.includes('lolin')) {
    return 'MGateway';
  }

  if (
    hwType.includes('lilygo') ||
    hwType.includes('sim7670') ||
    hwModel.includes('sim7670') ||
    hwModel.includes('tsim')
  ) {
    return 'LGateway';
  }

  if (hwType.includes('kgateway')) {
    return 'KGateway';
  }

  if (mqttTopic.startsWith('lilygo/')) {
    return hwModel.includes('lolin') ? 'MGateway' : 'LGateway';
  }

  if (mqttTopic.startsWith('kbeacon/')) {
    return 'KGateway';
  }

  return 'KGateway';
}

/** Human-readable hardware model for cards (prefers DB `hardware_model`). */
export function getGatewayModelDisplay(gateway) {
  const model = String(gateway?.hardware_model || '').trim();
  if (model) return model;

  const family = getGatewayProductFamily(gateway);
  if (family === 'LGateway') return 'T-SIM7670G';
  if (family === 'MGateway') return 'LOLIN32';
  return family;
}

export function getGatewayProductTagType(family) {
  if (family === 'LGateway') return 'teal';
  if (family === 'MGateway') return 'purple';
  return 'blue';
}

/** Supabase `hardware_type` for firmware_releases / OTA (Lolin vs LilyGO). */
export function getGatewayHardwareType(gateway) {
  const family = getGatewayProductFamily(gateway);
  if (family === 'MGateway') return 'wemos_lolin32';
  if (family === 'LGateway') return 'lilygo_tsim7670g';
  if (family === 'KGateway') return 'kgateway';
  const hwType = normalize(gateway?.hardware_type);
  return hwType || 'kgateway';
}
